import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { TiposCredenciaisApi } from '@/services/api-routes'
import { emptyPage } from '@/types/api'
import type { ListarTiposCredenciaisFiltro, TipoCredencialResumo } from '@/types/tipo-credencial'
import { tiposCredenciaisKeys } from '@/http/queryKeys'
import { defaultOptions } from '@/http/default-query-options'

export const useTiposCredenciaisQuery = (filtro: ListarTiposCredenciaisFiltro, enabled = true) =>
  useQuery({
    queryKey: tiposCredenciaisKeys.list(filtro),
    queryFn: async ({ signal }) =>
      (await TiposCredenciaisApi.listar(filtro, signal)) ?? emptyPage<TipoCredencialResumo>(),
    placeholderData: keepPreviousData,
    enabled,
    ...defaultOptions,
  })

export const useTipoCredencialQuery = (tipoCredencialId: string | undefined) =>
  useQuery({
    queryKey: tiposCredenciaisKeys.detail(tipoCredencialId ?? ''),
    queryFn: ({ signal }) => TiposCredenciaisApi.obter(tipoCredencialId as string, signal),
    enabled: Boolean(tipoCredencialId),
    ...defaultOptions,
  })

export const useInterfacesAutorizacaoQuery = (enabled = true) =>
  useQuery({
    queryKey: tiposCredenciaisKeys.interfaces(),
    queryFn: async ({ signal }) => (await TiposCredenciaisApi.interfaces(signal)) ?? [],
    enabled,
    ...defaultOptions,
  })
